import { MenuItem } from "@mui/material";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  getFormEmployers
} from "../../../../actions/forms";
import { getCuilCuit } from "../../../../utils/util";
import GooglePlacesAutocomplete from "../../../commons/formComponents/GooglePlacesAutocomplete";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikDatePicker from "../../../commons/formik/formikDatePicker";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import { StyledCommonForms } from "../../../styled/form";
import DiagnosisControlContainer from "../diagnosisControl/diagnosisControlContainer";
import FormSectionDivider from "../formSectionDivider";
import { siniestroValidation, validateRequiredFields } from "../formValidation";

const AccidentForm = ({
  handleClose,
  handleSubmit,
  model,
  form,
  artId,
  fromFacade,
  employers,
  diagnosis,
  isEditMode = false,
}) => {
  const dispatch = useDispatch();

  const setDireccionValue = (setFieldValue, field, value) => {
    setFieldValue(field, value ? value : "");
  };

  const setDireccion = (setFieldValue, value, isTrabajador) => {
    const aux = isTrabajador ? "Trabajador" : "Empleador";

    setDireccionValue(setFieldValue, `calle${aux}`, value.calle);
    setDireccionValue(setFieldValue, `numero${aux}`, value.numero);
    setDireccionValue(setFieldValue, `localidad${aux}`, value.localidad);
    setDireccionValue(setFieldValue, `provincia${aux}`, value.provincia);
    setDireccionValue(setFieldValue, `codigoPostal${aux}`, value.codigoPostal);
  };


  const diagnosisIsFound = useMemo(() => {
    return diagnosis.some((d) => d.id === form.diagnosticoOMS);
  }, [diagnosis, form.diagnosticoOMS]);

  return (
    <FormikForm
      artFields={model}
      initialValues={form}
      enableReinitialize
      validationSchema={() => siniestroValidation(fromFacade, isEditMode, form.fechaHoraAbandonoTrabajo)}
      validate={(values) => validateRequiredFields(values, model)}
      onSubmit={(values) => {
        handleSubmit(values);
      }}>
      {({ setFieldValue, values }) => (
        <StyledCommonForms.FormContainer>

          <StyledCommonForms.FieldContainer>
            <FormSectionDivider
              title="Siniestro"
              subtitle={
                form.presiniestro
                  ? '"LOS DATOS AQUI MOSTRADOS CORRESPONDEN A UN PRESINIESTRO DE LA ART"'
                  : null
              }
            />
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikAutocomplete
                  name="tipoSucesoArt"
                  label={`Tipo ${model.tipoSucesoArt.required ? "*" : ""}`}
                  variant="outlined"
                  options={model.tipoSucesoArt.options}
                  disabled={fromFacade && !isEditMode && !!form.tipoSucesoArt}
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikDateTimePicker
                  name="fechaHoraAccidente"
                  label={`Fecha Hora Accidente ${model.tipoSucesoArt.required ? "*" : ""
                    }`}
                  inputVariant="outlined"
                  disableFuture
                  autoComplete="off"
                  disabled={fromFacade && !isEditMode && !!form.fechaHoraAccidente}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="nroSiniestroArt"
                  label={`Nro Siniestro ART ${model.nroSiniestroArt.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                  disabled={fromFacade && !isEditMode && !!form.nroSiniestroArt}
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikDatePicker
                  name="fechaReagravacion"
                  variant="outlined"
                  label={`Fecha Reagravación ${model.fechaReagravacion.required ? "*" : ""
                    }`}
                  inputVariant="outlined"
                  autoComplete="off"
                  disabled={fromFacade && !isEditMode && !!form.fechaReagravacion}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikAutocomplete
                name="referenteApellidoyNombre"
                label={`Referente ART ${model.referenteApellidoyNombre.required ? "*" : ""
                  }`}
                variant="outlined"
                options={model.referenteApellidoyNombre.options}
                callBack={(value) => {
                  if (value) {
                    setFieldValue("idReferenteExterno", value.id);
                    setFieldValue("referenteEmail", value.email);
                  } else {
                    setFieldValue("idReferenteExterno", null);
                    setFieldValue("referenteEmail", null);
                  }
                }}
                returnProp="nombre"
                disabled={
                  fromFacade && !isEditMode && form.referenteApellidoyNombre ? true : false
                }
              />
            </StyledCommonForms.RowContainer>
            <DiagnosisControlContainer
              idArt={artId}
              fields={model}
              showDiagnosticoInformadoArt={fromFacade && !diagnosisIsFound}
              disabledIfInitialValueExists={fromFacade}
            />
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikDateTimePicker
                  name="fechaHoraAbandonoTrabajo"
                  label={`Fecha Hora Abandono de Trabajo ${(model.fechaHoraAbandonoTrabajo?.required || model.fechaHoraAbondonoTrabajo?.required) ? "*" : ""
                    }`}
                  inputVariant="outlined"
                  disableFuture
                  autoComplete="off"
                  disabled={fromFacade && !isEditMode && !!form.fechaHoraAbandonoTrabajo}
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikSelect
                  name="agenteCausante"
                  value={form.agenteCausante}
                  label={`Agente Material ${model.agenteCausante?.required ? "*" : ""}`}
                  variant="outlined"
                  disabled={fromFacade && !isEditMode && !!form.agenteCausante}
                >
                  {(model.agenteCausante?.options || []).map((option) => {
                    const optionValue =
                      typeof option === "object" ? option.id : option;
                    const optionLabel =
                      typeof option === "object" ? option.nombre : option;

                    return (
                      <MenuItem value={optionValue} key={optionValue}>
                        {optionLabel}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextField
                name="comoOcurrioAccidente"
                label={`¿Cómo ocurrió el accidente? ${model.comoOcurrioAccidente?.required ? "*" : ""
                  }`}
                type="text"
                variant="outlined"
                multiline
                minRows={3}
                disabled={fromFacade && !isEditMode && !!form.comoOcurrioAccidente}
              />
            </StyledCommonForms.RowContainer>
            <FormSectionDivider title="Trabajador" />
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikSelect
                  name="tipoDocumentoTrabajador"
                  value={form.tipoDocumentoTrabajador}
                  label={`Tipo Documento ${model.tipoDocumentoTrabajador.required ? "*" : ""
                    }`}
                  variant="outlined"
                  disabled={fromFacade && !isEditMode && !!form.tipoDocumentoTrabajador}>
                  {model.tipoDocumentoTrabajador.options.map((t) => (
                    <MenuItem value={t} key={t}>
                      {t}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="numeroDocumentoTrabajador"
                  label={`Número Documento ${model.numeroDocumentoTrabajador.required ? "*" : ""
                    }`}
                  type="number"
                  variant="outlined"
                  disabled={true}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="apellidoTrabajador"
                  label={`Apellido ${model.apellidoTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                  disabled={fromFacade && !isEditMode && !!form.apellidoTrabajador}
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="nombreTrabajador"
                  label={`Nombre ${model.nombreTrabajador.required ? "*" : ""}`}
                  type="text"
                  variant="outlined"
                  disabled={fromFacade && !isEditMode && !!form.nombreTrabajador}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikDatePicker
                  name="fechaNacimientoTrabajador"
                  variant="outlined"
                  label={`Fecha Nacimiento ${model.fechaNacimientoTrabajador.required ? "*" : ""
                    }`}
                  inputVariant="outlined"
                  disableFuture
                  autoComplete="off"
                  disabled={fromFacade && !isEditMode && !!form.fechaNacimientoTrabajador}
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikSelect
                  name="sexoTrabajador"
                  value={form.sexoTrabajador}
                  label={`Sexo ${model.sexoTrabajador.required ? "*" : ""}`}
                  variant="outlined"
                  disabled={fromFacade && !isEditMode && !!form.sexoTrabajador}
                  callBack={(value) => {
                    if (
                      value &&
                      values.numeroDocumentoTrabajador &&
                      // Si el CUIL/CUIT es traido por el validador, debemos usar
                      // ese valor. De lo contrario, el boton de sexo va a sobreescribir
                      // el valor de CUIL/CUIT durante el callback.
                      !fromFacade
                    ) {
                      setFieldValue(
                        "cuilCuitTrabajador",
                        getCuilCuit(values.numeroDocumentoTrabajador, value),
                      );
                    }
                  }}>
                  {model.sexoTrabajador.options.map((s) => (
                    <MenuItem value={s.id} key={s.id}>
                      {s.nombre}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextField
                name="cuilCuitTrabajador"
                label={`Cuil ${model.cuilCuitTrabajador.required ? "*" : ""}`}
                type="text"
                variant="outlined"
                disabled={fromFacade && !isEditMode && form.cuilCuitTrabajador}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <GooglePlacesAutocomplete
                handleSubmit={(value) =>
                  setDireccion(setFieldValue, value, true)
                }
                idArt={artId}
                label="Buscar una dirección para autocompletar los campos"
                variant="outlined"
                type="search"
                autoComplete="off"
                fullWidth
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="calleTrabajador"
                  label={`Calle ${model.calleTrabajador.required ? "*" : ""}`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="numeroTrabajador"
                  label={`Número ${model.numeroTrabajador.required ? "*" : ""}`}
                  type="number"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="pisoTrabajador"
                  label={`Piso ${model.pisoTrabajador.required ? "*" : ""}`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="departamentoTrabajador"
                  label={`Departamento ${model.departamentoTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="localidadTrabajador"
                  label={`Localidad ${model.localidadTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="provinciaTrabajador"
                  label={`Provincia ${model.provinciaTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextField
                name="codigoPostalTrabajador"
                label={`Código postal ${model.codigoPostalTrabajador.required ? "*" : ""
                  }`}
                type="number"
                variant="outlined"
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="areaTelefonosTrabajador"
                  label={`Área Teléfono ${model.areaTelefonosTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="telefonosTrabajador"
                  label={`Teléfono ${model.telefonosTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="areaTelefonoCelularTrabajador"
                  label={`Área Celular${model.areaTelefonoCelularTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="telefonoCelularTrabajador"
                  label={`Celular ${model.telefonoCelularTrabajador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <FormSectionDivider title="Empleador" />
            <StyledCommonForms.RowContainer>
              <FormikAutocomplete
                name="cuitEmpleador"
                optionId="cuit"
                label={`Cuit ${model.cuitEmpleador.required ? "*" : ""}`}
                variant="outlined"
                options={employers}
                getOptions={() => dispatch(getFormEmployers(artId))}
                callBack={(value) => {
                  setFieldValue(
                    "razonSocialEmpleador",
                    value ? value.razonSocial || "" : "",
                  );
                  setFieldValue(
                    "calleEmpleador",
                    value ? value.calle || "" : "",
                  );
                  setFieldValue(
                    "numeroEmpleador",
                    value ? value.numero || "" : "",
                  );
                  setFieldValue("pisoEmpleador", value ? value.piso || "" : "");
                  setFieldValue(
                    "departamentoEmpleador",
                    value ? value.departamento || "" : "",
                  );
                  setFieldValue(
                    "localidadEmpleador",
                    value ? value.localidad || "" : "",
                  );
                  setFieldValue(
                    "provinciaEmpleador",
                    value ? value.provincia || "" : "",
                  );
                  setFieldValue(
                    "codigoPostalEmpleador",
                    value ? value.codigoPostal || "" : "",
                  );
                  setFieldValue(
                    "telefonosEmpleador",
                    value ? value.telefonos || "" : "",
                  );
                }}
                freeSolo={true}
                returnProp="cuit"
                labelOption={(option) => option.cuit}
                helperText="Nuevo Empleador"
                renderOption={(option) =>
                  `${option.cuit} - ${option.razonSocial}`
                }
                filterOptions={(option) => option.cuit + option.razonSocial}
              //disabled={fromFacade && !!form.cuitEmpleador}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextField
                name="razonSocialEmpleador"
                label={`Razón Social ${model.razonSocialEmpleador.required ? "*" : ""
                  }`}
                type="text"
                variant="outlined"
                disabled={fromFacade && !isEditMode && !!form.razonSocialEmpleador}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <GooglePlacesAutocomplete
                handleSubmit={(value) =>
                  setDireccion(setFieldValue, value, false)
                }
                idArt={artId}
                label="Buscar una dirección para autocompletar los campos"
                variant="outlined"
                type="search"
                autoComplete="off"
                fullWidth
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="calleEmpleador"
                  label={`Calle ${model.calleEmpleador.required ? "*" : ""}`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="numeroEmpleador"
                  label={`Número ${model.numeroEmpleador.required ? "*" : ""}`}
                  type="number"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="pisoEmpleador"
                  label={`Piso ${model.pisoEmpleador.required ? "*" : ""}`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="departamentoEmpleador"
                  label={`Departamento ${model.departamentoEmpleador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="localidadEmpleador"
                  label={`Localidad ${model.localidadEmpleador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="provinciaEmpleador"
                  label={`Provincia ${model.provinciaEmpleador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikTextField
                  name="codigoPostalEmpleador"
                  label={`Código postal ${model.codigoPostalEmpleador.required ? "*" : ""
                    }`}
                  type="number"
                  variant="outlined"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikTextField
                  name="telefonosEmpleador"
                  label={`Teléfono ${model.telefonosEmpleador.required ? "*" : ""
                    }`}
                  type="text"
                  variant="outlined"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
          </StyledCommonForms.FieldContainer>
          <StyledCommonForms.ActionsContainer>
            <FormikActions handleCancel={handleClose} />
          </StyledCommonForms.ActionsContainer>
        </StyledCommonForms.FormContainer>
      )}
    </FormikForm>
  );
};

export default AccidentForm;
